import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { useAudioPlayer } from '../hooks/useAudioPlayer';

export default function AudioPlayer({audio, title, onClose, onEnd}){

    const { play, toggle, seek, stop, isPlaying, currentTime, duration } = useAudioPlayer(onEnd);

    // Auto-play when audio URL changes
    useEffect(() => {
        if (audio) {
            play(audio);
        }
    }, [audio, play]);

    // Stop audio when component unmounts (e.g. user closes the player)
    useEffect(() => {
        return () => stop();
    }, [stop]);

    const formatTime = (secs, dur) => {

        const timeLeft = dur - secs;

        const minutes = Math.floor(timeLeft / 60) || 0;

        const seconds = Math.round(timeLeft - minutes * 60) || 0;

        return '-' + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

    };

    return (
        <div className="audio-player">
            <button 
                className="close-icon" 
                onClick={() => { stop(); onClose(); }}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                aria-label="Close"
            >
                <X size={20} />
            </button>
            <div className="control" onClick={toggle}>
                {
                    (isPlaying)?
                    (
                        <PauseIcon />
                    )
                    :
                    (
                        <PlayIcon />
                    )
                }
            </div>
            <div className="middle">
                <p className="title">{title}</p>
                <input
                    type="range" 
                    value={currentTime}
                    onChange={(e) => {
                        seek(Number(e.target.value));
                    }}
                    max={duration || 0}
                    step="0.1"
                />
                <div className="timer">
                    {formatTime(currentTime, duration)}
                </div>
            </div>
            <div className="tail" />
        </div>
    )

}

function PlayIcon(){
    return(
        <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23.5" cy="23.5" r="23.5" fill="var(--bs-primary)" />
            <path d="M34 24L19 32.6603V15.3397L34 24Z" fill="white"/>
        </svg>
    );
}

function PauseIcon(){
    return(
        <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23.5" cy="23.5" r="23.5" fill="var(--bs-primary)"/>
            <path d="M20 16V32M27 16V32" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
